import React, { useEffect } from 'react'
import styles from  './overview1.module.css'
import {Link, useNavigate} from 'react-router-dom'
const TOOLS=["HTML","CSS","TYPESCRIPT","REACT","NODE.JS","MYSQL","JWT","RESPONSIVE DESIGN"];

export default function Overview1() {
  const navigate=useNavigate();

  useEffect(()=>{
     window.scroll({top:0,behavior:"smooth"})
  },[])
 
  const navigateToProject=()=>{
       navigate('/project2')
  }
  const navigateToProject3=()=>{
    navigate('/project3')
}
  return (
    <div className={styles.overview1}>
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <span className={styles.text}>Classified</span>
          <span className={styles.sub}>Local classified website</span>
        </div>
        <h3 className={styles.header}>Overview</h3>
        <p className={styles.overview}>
          Classifed is a website where you can easily find Ads you need by categories, entering keyword, 
          filtering by conditions in several specific regions.
          You can also save your favorite ads for later and keep track of ads you have checked
          by favorite.
        </p>
        <div className={styles.tools}>
          {TOOLS.map((t,index)=>(
            <span className={styles.tool} key={index}>{t}</span>
          ))}
        </div>
        <div className={styles.devices}>
            <div className={styles["macbook-container"]}>
              <img src="./images/macbook.png" alt="" className={styles.macbook} />
              <img src="./images/classified.png" alt="" className={styles["inside-img-mac"]} />
              <img src="./images/classified-mobile.png" alt="" className={styles.phone}/>
              <img src="./images/classified-pad.png" alt="" className={styles.ipad}/>
            </div>
        </div>
        <h3 className={styles.header}>Design</h3>
        <div className={styles.gallery}>
            <img src="./images/classified-fullNew.png" alt="" className={styles["classified-full"]} />
            <img src="./images/classified-list.png" alt="" className={styles["classified-list"]} />
            <img src="./images/classified-ads.png" alt="" className={styles["classified-contents"]} />
        </div>
        <div className={styles.icons}>
            <a href="https://www.linkedin.com/in/ryo-aoyama-21392222b/"><img src="./images/linkedin2.png" alt="" className={styles.linkedin}/></a>
            <a href="https://github.com/RyoGitacc/Classified"><img src="./images/github-mark.png" alt="" className={styles.github}/></a>
        </div>
        <div className={styles['btn-container']}>
            <a href='https://classified-ryo-aoyama.netlify.app/'>
            <button className={styles.btn}>Visit Website</button>
            </a>
        </div>
        <h3 className={styles.header}>More Works</h3>
        <div className={styles["more-work"]}>
           <div className={styles.ryotube} onClick={navigateToProject}></div>
           <div className={styles.notyet} onClick={navigateToProject3}></div>
        </div>
        <p className={styles.back}>
          <Link to='/' className={styles.link}>
            Back to home
          </Link>
        </p>
      </div>
    </div>
  )
}
